







































































































































import { Component, Vue } from "vue-property-decorator";
import { SurveyType, Attractor, SurveyStatusType } from "@/interfaces";

import { SurveyModule } from "@/store";
import { getAttractors, deleteAttractor } from "@/services";
import { notifyError, notifySuccess } from "@/common/notify";

import { date } from "quasar";

@Component
export default class AttractorsSurvey extends Vue {
  @SurveyModule.bindings.Mutation
  setSurveyType!: (type: SurveyType | null) => void;

  attractors: Attractor[] = [];

  loading = false;

  filteredData: Attractor[] = [];

  searchText = "";

  async mounted() {
    try {
      this.attractors = await getAttractors();
      this.setSurveyType(SurveyType.ATTRACTION);
      this.filteredData = this.attractors;
    } catch (error) {
      console.log(error);
    }
  }

  goToSurvey() {
    this.$router.push(`survey/${SurveyType.ATTRACTION}`).catch(error => console.log(error));
  }

  dataSearchSubmit() {
    if (this.searchText.trim() !== "") {
      this.filteredData = this.attractors.filter(attractor =>
        attractor.name.toLowerCase().includes(this.searchText.toLowerCase()),
      );
    } else {
      this.filteredData = this.attractors;
    }
  }

  openShowAttractor(attractor: Attractor) {
    this.$router.push(`survey/${SurveyType.ATTRACTION}/${attractor.surveys[0].id}`).catch(error => console.log(error));
  }

  getAttractorDate(attractor: Attractor) {
    return date.formatDate(attractor.surveys[0].updated_at, "DD/MM/YYYY HH:mm");
  }

  onDeleteAttractor(attractor: Attractor) {
    this.$q
      .dialog({
        title: "Attenzione",
        message: `Sei sicuro di volere eliminare l'attrattore <strong>${attractor.name}</strong>`,
        html: true,
        cancel: true,
      })
      .onOk(() => {
        this.deleteAttractorAction(attractor);
      });
  }

  async deleteAttractorAction(attractor: Attractor) {
    try {
      await deleteAttractor(attractor.id);
      this.attractors = await getAttractors();
      this.filteredData = this.attractors;
      this.searchText = "";
      notifySuccess("Attrattore rimosso con successo!");
    } catch (error) {
      console.log(error);
      notifyError("Errore imprevisto, non è stato possibile eliminare l'attrattore!");
    }
  }

  get statusLabelClass() {
    return (status: SurveyStatusType) => {
      switch (status) {
        case SurveyStatusType.COMPLETED:
          return "text-positive";
        case SurveyStatusType.IN_PROGRESS:
          return "text-warning";
        default:
          return "";
      }
    };
  }

  get statusLabel() {
    return (status: SurveyStatusType) => {
      switch (status) {
        case SurveyStatusType.COMPLETED:
          return "Completato";
        case SurveyStatusType.IN_PROGRESS:
          return "Da Completare";
        default:
          return "Indefinito";
      }
    };
  }

  get columns() {
    return [
      {
        name: "name",
        label: "Nome",
        field: "name",
        align: "left",
        sortable: true,
      },
      {
        name: "status",
        label: "Stato",
        field: (row: Attractor) => (row.surveys.length > 0 ? this.statusLabel(row.surveys[0].status) : ""),
        align: "left",
        sortable: true,
      },
      {
        label: "Ultima modifica",
        name: "date",
        field: (row: Attractor) =>
          row.surveys.length > 0 ? date.formatDate(row.surveys[0].updated_at, "DD/MM/YYYY HH:mm") : "",
        align: "left",
        sortable: true,
      },
      { name: "edit", align: "center" },
      { name: "complete", align: "center" },
      { name: "delete", align: "center" },
    ];
  }
}
